var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.048 19.675-4.307 4.416a8.467 8.467 0 0 1-12.184 0c-3.364-3.448-3.363-9.039.001-12.488l8.699-8.916a8.467 8.467 0 0 1 12.183 0c3.364 3.448 3.364 9.039 0 12.488l-4.307 4.414a1.316 1.316 0 0 1-.085.086Zm-.829-2.723 3.477-3.564c2.402-2.462 2.402-6.453.001-8.915a6.045 6.045 0 0 0-8.697 0L9.522 8.039l8.697 8.914Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefill);
export default __webpack_public_path__ + "static/media/refill.928084ded1305d790b4ab54c4a8ddac5.svg";
export { ForwardRef as ReactComponent };